import React, { useEffect } from "react";
import { Window, WindowActionsBar, WindowActionsEvent, WindowMoveEvent } from '@progress/kendo-react-dialogs';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { TicketLocationState } from "../Ticket/TicketRoute";
import { Api } from "../../redux/api/BaseApi";
import { isMobile } from 'react-device-detect';
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import AddAction from "../Ticket/TicketDetails/Sections/AddAction";
import { TicketApi } from "../../redux/api/TicketApi";
import * as ActionSlice from "../../slices/ActionSlice";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svg from "@progress/kendo-svg-icons";

const ActionModal: React.FunctionComponent<any> = props => {
    let { ticketId, actionId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    let background = location.state && (location.state as TicketLocationState).background;
    const [previousPage] = React.useState<Location>(background);
    const dispatch = useReduxDispatch();
    let goBack = () => {

        if (previousPage)
            navigate(previousPage);
        else
            navigate('/ticket/' + ticketId);
    };
    const { action: existingAction } = useReduxSelector(state => state.actionDetails);
    const { data: details, isFetching } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
    const [stage, setStage] = React.useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const [dialogVisible, setDialogVisible] = React.useState<boolean>(false);
    // const [expanded, setExpanded] = React.useState<boolean>(true);
    const maxHeight = Math.min(window.innerHeight - 200, 600);
    const [size, setSize] = React.useState<windowDims>({ w: Math.max(window.innerWidth - 200, Math.min(500, window.innerWidth)), h: maxHeight });
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const resizing = (e: WindowMoveEvent) => {
        //console.log('resizing', e.width)
        setSize({ t: e.top, l: e.left, w: e.width, h: e.height })
        // setExpanded(e.width < 660 ? false : true);
    }

    const moving = (e: WindowMoveEvent) => {
        if (e.top !== size.t || e.left !== size.l) {
            //console.log('moving')
            setSize({ ...size, t: e.top, l: e.left })
        }
    }

    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    window.onresize = (e: UIEvent) => {
        console.log('window resizing')
        let popupWidth = window.innerWidth - 200;
        setSize({ w: popupWidth, h: undefined, t: undefined, l: undefined })

        // setExpanded(popupWidth < 660 ? false : true);
    }

    //when in fullscreen mode set overflow hidden on the body to prevent scrolling
    useEffect(() => {
        if (stage === 'FULLSCREEN') {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        //when the component unmounts set overflow back to auto
        return () => {
            document.body.style.overflow = 'auto';
        }
    }, [stage]);

    const requiredStyleClass = `.k-window .k-window-titlebar{
        background-color: ${userProfile?.Nav_Hex_Color};    
        color:#fff;
    }
    .k-window{background-color: #ddd;}`

    return (
        <>
            <style>
                {requiredStyleClass}
            </style>
            <Window minimizeButton={() => null} onMove={moving} top={size.t} left={size.l} width={size.w} height={size.h} onResize={resizing} className={stage === 'FULLSCREEN' ? 'edit-action-window full-screen' : 'edit-action-window'} onClose={goBack} title={<><SvgIcon className="mr-2" icon={svg.trackChangesEnableIcon} />{existingAction?.ID == 0 ? 'New' : 'Edit'} {userProfile?.Phrases.Action || '...'}</>} modal={true} stage={stage} onStageChange={onStageChange} >

                <AddAction ticket={details} actionId={parseInt(actionId)} onsubmitted={() => {
                    navigate('/ticket/' + ticketId);
                }} />
                <Outlet />
            </Window>
        </>
    );
}
type windowDims = {
    w: number,
    h: number,
    t?: number,
    l?: number
}

export default ActionModal;